import { put, takeLatest, select } from 'redux-saga/effects';
import {
  GET_SPECIAL_INFO_55,
  APP_DETAILS,
  SPECIALLIST_TAGS_64,
  SPECIALLIST_LIST_64,
  GROUNP_CONTENT_53,
  SPECIAL_ZAN_70,
  ZT_VIEW_PAGE_70,
} from '../config';

import {
  GET_SPECIAL_INFO_REQUEST,
  GET_SPECIAL_INFO_SUCCESS,
  GET_APP_DETAILS,
  SET_APP_DETAILS,
  GET_SPECIALLIST_TAGS,
  GET_SPECIALLIST_LIST,
  GET_SPECIALLIST_BY_SOURCE,
  RESET_RESET_SPRCIAL_INFO,
  GET_SPECIAL_TAGS_SUCCESS,
  GET_SPECIAL_LIST_SUCCESS,
  GET_SPECIALLIST_BY_SOURCE_SUCCESS,
  SET_SPECIAL_ZAN,
} from '../constants/special';

import { createAxios, logNative } from '../utils/utils';

/**
 * 游戏频道banners
 */
function* fetchSpecialInfo({ ztId, viewPage }) {
  try {
    const url = viewPage === '1' ? ZT_VIEW_PAGE_70 : GET_SPECIAL_INFO_55;
    const param = viewPage === '1' ? { ztId, viewPage } : { ztId };
    const axios = yield createAxios();
    const res = yield axios.get(url, { params: param });
    if (res.data.status === 0) {
      yield put({
        type: GET_SPECIAL_INFO_SUCCESS,
        payload: {
          ...res.data.data,
        },
      });
    } else {
      yield put({
        type: GET_SPECIAL_INFO_SUCCESS,
        payload: {
          ztId,
          isOffLine: true,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchSpecialInfo() {
  yield takeLatest(GET_SPECIAL_INFO_REQUEST, fetchSpecialInfo);
}

/**
 * 竞品安装 获取软件详情
 */

function* fetchAppDetails({ softid = '', bizInfo = {} }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(APP_DETAILS, { params: { softid, bizInfo: bizInfo || {} } });
    if (res.data.status === 0) {
      yield put({
        type: SET_APP_DETAILS,
        payload: { ...res.data.data, paramSoftId: softid, loading: false },
      });
    } else {
      yield put({
        type: SET_APP_DETAILS,
        payload: { ...res.data, paramSoftId: softid, loading: false },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchlFetchSpeciaAppDetails() {
  yield takeLatest(GET_APP_DETAILS, fetchAppDetails);
}

/**
 *
 * @param {*} callback 回调函数  返回后端响应数据
 * 本接口获取专题标签列表
 */
function* fetchSpecialListTags() {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(SPECIALLIST_TAGS_64);
    if (res.data.status === 0) {
      yield put({
        type: GET_SPECIAL_TAGS_SUCCESS,
        payload: res.data.data,
      });
    } else {
      yield put({
        type: GET_SPECIAL_TAGS_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchSpecialListTags() {
  yield takeLatest(GET_SPECIALLIST_TAGS, fetchSpecialListTags);
}

function* fetchSpecialListList({ payload }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(SPECIALLIST_LIST_64, {
      params: payload,
    });
    if (res.data.status === 0) {
      const curList = (res.data.data && res.data.data.ztList) || [];

      yield put({
        type: GET_SPECIAL_LIST_SUCCESS,
        payload: {
          specialList: curList,
          pagenation: {
            ...payload,
            count: res.data.data.count,
            error: false,
            loading: false,
          },
        },
      });
    } else {
      yield put({
        type: GET_SPECIAL_LIST_SUCCESS,
        payload: {
          specialList: [],
          pagenation: {
            ...payload,
            count: 0,
            loading: false,
            error: res.data.status !== 200500,
          },
        },
      });
    }

    // eslint-disable-next-line no-empty
  } catch (error) {
    yield put({
      type: GET_SPECIAL_LIST_SUCCESS,
      payload: {
        specialList: [],
        pagenation: {
          ...payload,
          count: 0,
          loading: false,
          error: true,
        },
      },
    });
  }
}

export function* watchFetchSpecialListList() {
  yield takeLatest(GET_SPECIALLIST_LIST, fetchSpecialListList);
}

/**
 * 根据页面来源类型获取专题列表数据，内嵌到专题详情页，或者搜索，，空白内容推荐等
 */

function* fetchSpecialListBySource({ payload: { params } }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GROUNP_CONTENT_53, {
      params,
    });
    if (res.data.status === 0) {
      yield put({
        type: GET_SPECIALLIST_BY_SOURCE_SUCCESS,
        payload: res.data.data,
      });
    }
  } catch (err) {
    logNative(`根据页面来源类型获取专题列表数据失败${err}`, err);
  }
}
export function* watchFetchSpecialListBySource() {
  yield takeLatest(GET_SPECIALLIST_BY_SOURCE, fetchSpecialListBySource);
}

/**
 *
 * 页面注销时清空专题详情页面存储的数据
 */

function* fetchResetSpecialInfo({ payload: { params } }) {
  try {
    yield put({
      type: GET_SPECIAL_INFO_SUCCESS,
      payload: params,
    });
  } catch (err) {
    logNative(`页面注销时清空专题详情页面存储的数据${err}`, err);
  }
}
export function* watchFetchResetSpecialInfo() {
  yield takeLatest(RESET_RESET_SPRCIAL_INFO, fetchResetSpecialInfo);
}
// 专题点赞
function* fetchSetSpecialZan({ payload }) {
  try {
    const axios = yield createAxios();
    yield axios.get(SPECIAL_ZAN_70, {
      params: payload,
    });
  } catch (err) {
    logNative(`增加专题页面点赞数${err}`, err);
  }
}
export function* watchFetchSetSpecialZan() {
  yield takeLatest(SET_SPECIAL_ZAN, fetchSetSpecialZan);
}
